import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../client.ts';
import type { BuilderQuestionsResponse } from '../bindings/BuilderQuestionsResponse.ts';
import type { AnswersResponse } from '../bindings/AnswersResponse.ts';

export function useBuilderQuestions() {
  return useQuery({
    queryKey: ['builder-questions'],
    queryFn: () => apiFetch<BuilderQuestionsResponse>('/v1/builder/questions'),
    staleTime: Infinity,
  });
}

export function useAnswers(planId: string | undefined) {
  return useQuery({
    queryKey: ['answers', planId],
    queryFn: () => apiFetch<AnswersResponse>(`/v1/plans/${planId}/answers`),
    enabled: !!planId,
  });
}

export function usePutAnswer(planId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ key, answer }: { key: string; answer: string | string[] }) =>
      apiFetch<void>(`/v1/plans/${planId}/answers/${key}`, {
        method: 'PUT',
        body: JSON.stringify({ answer }),
      }),
    onMutate: ({ key, answer }) => {
      // optimistic: the wizard is the only writer of answers
      queryClient.setQueryData<AnswersResponse>(['answers', planId], (prev) =>
        prev ? { ...prev, answers: { ...prev.answers, [key]: answer } } : prev,
      );
    },
  });
}
